import axios from "axios";
import { BACKEND_URL } from "@/lib/backend";

// T66: signed-in customers' back-in-stock alerts
const api = axios.create({ baseURL: `${BACKEND_URL}/api`, withCredentials: true });
api.interceptors.request.use((cfg) => {  // T21-FIX2: state-changing customer calls carry the customer CSRF token
  if (cfg.method && cfg.method !== "get") {
    const m = document.cookie.match(/(?:^|; )rst_customer_csrf=([^;]*)/);
    if (m) cfg.headers = { ...(cfg.headers || {}), "X-CSRF-Token": decodeURIComponent(m[1]) };
  }
  return cfg;
});
export const listStockAlerts = () => api.get("/account/stock-alerts").then((r) => r.data.alerts);
export const addStockAlert = (product_id) => api.post("/account/stock-alerts", { product_id }).then((r) => r.data);
export const removeStockAlert = (id) => api.delete(`/account/stock-alerts/${id}`).then((r) => r.data);
